
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { JobCriteria } from '../../keep/models/job-criteria.model';
import { AppUrl } from '../constants/app-urls';
import { DealerCriteria } from '../../account/models/dealer-criteria.model';
import { CarCriteria } from '../../car/models/car-criteria.model';
import { CarBusinessLine } from '../../car/constants/car-basic-data';



const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

@Injectable({
  providedIn: 'root',
})
export class SearchService {
    
  constructor(private router: Router, private http: HttpClient) {}

//preview

  getSearchedCarsPreviewByCriteria(criteria: CarCriteria): Observable<any>{ 

    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    //const params = new HttpParams().append('make', criteria.makes);
    //console.log("helloo "+criteria);
    //console.log(criteria);
    let c = Object.assign(new CarCriteria(), criteria)
    //console.log(criteria.etT());
    
    let params: HttpParams = c.getHttpParams();

    //console.log("params = " +params)
    
    switch(criteria.businessLine!.toString()){
      case CarBusinessLine.BUY.toString():{
        return this.http.get<any>(AppUrl.buySearchCarPreviews, {headers, params} );
        break;
      }
      case CarBusinessLine.RENT.toString():{
        return this.http.get<any>(AppUrl.rentSearchCarPreviews, {headers, params} );
        break;
      }
      
      default:{
        return of(null);
        break;
      }
    }

  }

  
  getSearchedDealersPreviewByCriteria(criteria: DealerCriteria): Observable<any>{ 

    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let c = Object.assign(new DealerCriteria(), criteria)
    
    let params: HttpParams = c.getHttpParams();

    return this.http.get<any>(AppUrl.dealerSearchPreview, {headers, params} );

  }

  //activities

  getSearchedActivitiesPreviewByCriteria(criteria: JobCriteria): Observable<any>{ 

    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let c = Object.assign(new JobCriteria(), criteria)
    
    let params: HttpParams = c.getHttpParams();

    return this.http.get<any>(AppUrl.jobSearchPreview, {headers, params} );

  }

// details

  getSearchedCarsByCriteria(criteria: CarCriteria): Observable<any>{ 

    //let query = 
      
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    //const params = new HttpParams().append('make', criteria.makes);
    //console.log("helloo "+criteria);
    //console.log(criteria);
    let c = Object.assign(new CarCriteria(), criteria)
    //console.log(JSON.stringify(criteria));
    
    let params: HttpParams = c.getHttpParams();
  
    switch(criteria.businessLine!.toString()){
      case CarBusinessLine.BUY.toString():{
        return this.http.get<any>(AppUrl.buySearchCarDetails, {headers, params} );
        break;
      }
      case CarBusinessLine.RENT.toString():{
        return this.http.get<any>(AppUrl.rentSearchCarDetails, {headers, params} );
        break;
      }
      
      default:{
        return of();
        break;
      }
    }
    
  }

  getSearchedDealersByCriteria(criteria: DealerCriteria): Observable<any>{ 

    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let c = Object.assign(new DealerCriteria(), criteria)
    
    let params: HttpParams = c.getHttpParams();
  
    return this.http.get<any>(AppUrl.dealerSearchPublic, {headers, params} );
    
  }

  getSearchedActivitiesByCriteria(criteria: JobCriteria): Observable<any>{ 

    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let c = Object.assign(new JobCriteria(), criteria)
    
    let params: HttpParams = c.getHttpParams();
  
    return this.http.get<any>(AppUrl.jobSearch, {headers, params} );
    
  }


  // others

  getCarDetailsByIds(offerId: string, carId: string, businessLine?: CarBusinessLine): Observable<any>{

    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    let criteria = new CarCriteria();
    criteria.offerIds = offerId === "" ? [] : [offerId];
    criteria.carIds = carId === "" ? [] : [carId];
    criteria.businessLine = businessLine!;
    
    //c.businessLines = businessLines;
    //console.log("lines = "+criteria.getHttpParams())
    let params: HttpParams = criteria.getHttpParams();

    //console.log("params = " +params)
      
    //return this.http.get<any>(AppUrl.search, {headers, params} );

    return this.getSearchedCarsByCriteria(criteria)
    
  }

  getSimilarCarsByCarId(carId: string, offerId: string,businessLine: CarBusinessLine): Observable<any>{

    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    
    let params: HttpParams = new HttpParams().append('carId', carId).append('offerId', offerId)
      
    //return this.http.get<any>(AppUrl.search+"/similar", {headers, params} );

    //console.log(params)

      
    switch(businessLine!.toString()){
      case CarBusinessLine.BUY.toString():{
        return this.http.get<any>(AppUrl.buySearchCarBriefs+"/similar", {headers, params} );
        break;
      }
      case CarBusinessLine.RENT.toString():{
        return this.http.get<any>(AppUrl.rentSearchCarBriefs+"/similar", {headers, params} );
        break;
      }
      
      default:{
        return of(null);
        break;
      }
    }
    
  }
  
  getRecentCarBriefsByCountries(countryCodes: string[], businessLine: CarBusinessLine): Observable<any>{

    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let params: HttpParams = new HttpParams().append('countries', countryCodes.join(', '))

    switch(businessLine!.toString()){
      case CarBusinessLine.BUY.toString():{
        return this.http.get<any>(AppUrl.buySearchCarBriefs+"/recent", {headers, params} );
        break;
      }
      case CarBusinessLine.RENT.toString():{
        return this.http.get<any>(AppUrl.rentSearchCarBriefs+"/recent", {headers, params} );
        break;
      }
      
      default:{
        return of(null);
        break;
      }
    }
    
  }

  getCarBriefsByCriteria(c: CarCriteria): Observable<any>{

    const headers = new HttpHeaders().append('Content-Type', 'application/json');

    let params: HttpParams = c.getHttpParams();
      
    //return this.http.get<any>(AppUrl.search+"/briefs", {headers, params} );

    switch(c.businessLine!.toString()){
      case CarBusinessLine.BUY.toString():{
        return this.http.get<any>(AppUrl.buySearchCarBriefs, {headers, params} );
        break;
      }
      case CarBusinessLine.RENT.toString():{
        return this.http.get<any>(AppUrl.rentSearchCarBriefs, {headers, params} );
        break;
      }
      
      default:{
        return of(null);
        break;
      }
    }
    
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
